import React, { Fragment } from 'react';
import { Alert } from 'reactstrap';
// import uuid from 'uuid/v1';


export const AlertMessage = props => {  

  return (    
    <Fragment>
        { (props.alert?.message?.length > 0) ?                 
                <Alert key={props.alert.message} color={props.alert.color}>{props.alert.message}</Alert>
                : 
                <Fragment></Fragment>
        }
    </Fragment>
  );
};
